import { useEffect, useState } from "react"

const useAdmin = (email)=>{
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAdminLoading, setIsAdminLoading] = useState(true)
    useEffect(()=>{
        if(email){
            fetch(`https://doctors-portal-client-server-developertanbir-gmailcom.vercel.app/users/admin/${email}`, {
                headers: {
                    authorization: localStorage.getItem("token")
                }
            })
            .then(res=>res.json())
            .then(data=>{
                setIsAdmin(data.isAdmin)
                setIsAdminLoading(false)
            })
            .catch(error=>console.log(error))
        }
    }, [email])
    return [isAdmin, isAdminLoading];
}

export default useAdmin;